export class UserFilter {
    name: string;
    email: string;
    employeeRole: string;
    isActive: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/users/userFilter.ts